import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import type { MetricsStreamingFormat } from "../miContenidoExportData";
import type { ProgramRankingPdfRow } from "../programRanking/types";
import { ProgramRankCardsPdfSection } from "./ProgramRankCardsPdfSection";
import { PDF_FONT_FAMILY } from "./pdfTheme";

const styles = StyleSheet.create({
  section: {
    flex: 1,
    minHeight: 0,
    fontFamily: PDF_FONT_FAMILY,
  },
});

type Props = {
  rows: ProgramRankingPdfRow[];
  rankingPeriod?: { startDate: string; endDate: string } | null;
  podscopeActiveProgramCount?: number | null;
  streamingFormat?: MetricsStreamingFormat;
};

export function PeriodSummaryPdfSection({
  rows,
  rankingPeriod = null,
  podscopeActiveProgramCount = null,
  streamingFormat = "live",
}: Props): React.ReactElement | null {
  if (rows.length === 0) return null;

  return (
    <View style={styles.section}>
      <ProgramRankCardsPdfSection
        rows={rows}
        rankingPeriod={rankingPeriod}
        podscopeActiveProgramCount={podscopeActiveProgramCount}
        streamingFormat={streamingFormat}
      />
    </View>
  );
}
